@switch (inputType) {
  <!--STRING INPUT-->
  @case ('string') {
    <mat-form-field class="full-width">
      <input
        matInput
        [(ngModel)]="inputValue"
        type="text"
        [required]="required"
        [placeholder]="placeholder"
        [disabled]="disabled"
        (input)="emitValue($any($event.target).value)"
        (blur)="onBlur()"
        #inputField="ngModel"
      >
      <mat-error><app-form-field-error [error]="controlErrors"></app-form-field-error></mat-error>
    </mat-form-field>
  }

  <!--NUMBER INPUT-->
  @case ('number') {
    <mat-form-field class="full-width">
      <input
        #inputField="ngModel"
        [(ngModel)]="inputValue"
        matInput
        type="number"
        appDigitsOnly
        min="0"
        [required]="required"
        [placeholder]="placeholder"
        [disabled]="disabled"
        (input)="emitValue($any($event.target).value)"
        (blur)="onBlur()">
      <mat-error><app-form-field-error [error]="controlErrors"></app-form-field-error></mat-error>
    </mat-form-field>
  }

  <!--BOOLEAN-->
  @case ('boolean') {
    <mat-form-field class="full-width">
      <mat-select
        #inputField="ngModel"
        [(ngModel)]="inputValue"
        class="full-width"
        [placeholder]="placeholder"
        [required]="required"
        [disabled]="disabled"
        (selectionChange)="emitValue($event.value)"
        (blur)="onBlur()">
        <mat-option></mat-option>
        <mat-option [value]="true"><span translate>API.YES</span></mat-option>
        <mat-option [value]="false"><span translate>API.NO</span></mat-option>
      </mat-select>
      <mat-error><app-form-field-error [error]="controlErrors"></app-form-field-error></mat-error>
    </mat-form-field>
  }

  <!--DATEPICKER-->
  @case ('date') {
    <mat-form-field class="full-width">
      <input
        matInput
        [(ngModel)]="inputValue"
        type="date"
        [required]="required"
        [placeholder]="placeholder"
        [disabled]="disabled"
        (input)="emitValue($any($event.target).value)"
        (blur)="onBlur()"
        #inputField="ngModel"
      >
      <mat-error><app-form-field-error [error]="controlErrors"></app-form-field-error></mat-error>
    </mat-form-field>
  }

  <!-- DATETIMEPICKER -->
  @case ('datetime') {
    <mat-form-field class="full-width">
      <input
        matInput
        [(ngModel)]="inputValue"
        type="datetime-local"
        [min]="pastDateAllowed ? '' : todayDateTime"
        [required]="required"
        [placeholder]="placeholder"
        [disabled]="disabled"
        (input)="emitValue($any($event.target).value)"
        (blur)="onBlur()"
        #inputField="ngModel"
      >
      <mat-error><app-form-field-error [error]="controlErrors"></app-form-field-error></mat-error>
    </mat-form-field>
  }

  <!--ENUM-->
  @case ('enum') {
    <mat-form-field class="full-width">
      <mat-select
        #inputField="ngModel"
        [(ngModel)]="inputValue"
        class="full-width"
        [placeholder]="placeholder"
        [required]="required"
        [disabled]="disabled"
        (selectionChange)="emitValue($event.value)"
        (blur)="onBlur()">
        <mat-option></mat-option>
        @for (enumValue of enumValues; track enumValue.name) {
          <mat-option [value]="enumValue.name">
            @if (isCustomField) {
              {{ enumValue.label }}
            } @else {
              <span translate>{{ enumValue.label }}</span>
            }
          </mat-option>
        }
      </mat-select>
      <mat-error><app-form-field-error [error]="controlErrors"></app-form-field-error></mat-error>
    </mat-form-field>
  }

  <!--LIST-->
  @case ('multiple_select') {
    <mat-form-field class="full-width">
      <mat-select
        #inputField="ngModel"
        [(ngModel)]="inputValue"
        class="full-width"
        [placeholder]="placeholder"
        [multiple]="true"
        [required]="required"
        [disabled]="disabled"
        (selectionChange)="emitValue($event.value)"
        (blur)="onBlur()">
        @for (enumValue of enumValues; track enumValue.name) {
          <mat-option [value]="enumValue.name">
            {{ enumValue.label }}
          </mat-option>
        }
      </mat-select>
      <mat-error><app-form-field-error [error]="controlErrors"></app-form-field-error></mat-error>
    </mat-form-field>
  }

  <!-- ZONE_ID -->
  @case ('timezone') {
    <mat-form-field class="full-width">
      <mat-select
        #inputField="ngModel"
        [(ngModel)]="inputValue"
        class="full-width"
        [placeholder]="placeholder"
        [required]="required"
        [disabled]="disabled"
        (selectionChange)="emitValue($event.value)"
        (blur)="onBlur()">
        @for (timezone of (timezones$ | async); track timezone.id) {
          <mat-option [value]="timezone.id">
            ({{ timezone.offset }}) {{ timezone.id }}, {{ timezone.displayName }}
          </mat-option>
        }
      </mat-select>
      <mat-error><app-form-field-error [error]="controlErrors"></app-form-field-error></mat-error>
    </mat-form-field>
  }

}
